module.exports = __webpack_public_path__ + "static/media/219401028.eab9e4d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/219401028.png
// module id = 480
// module chunks = 0